import React from 'react';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';
import CustomBadge from 'components/CustomBadge';

//弹出mailmerge的div
export function docMergeQuote({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.QuoteId, mailMergeObj: parameter, dataModelType: 3 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(3, parameter.QuoteId);
  }, config.setTimeoutMilliSecond);
}

export function calculateTotal({ parameter, sectionComponent, pageComponent }) {
  let total = 0;
  let data = parameter.map((item, i) => {
    total += item.Total;
  })

  // 判断公司设置 ShowProjectTotalFeeInvoice 是否启用
  let showProjectTotal = pageComponent?.props?.authUser?.Company?.ShowProjectTotalFeeInvoice;
  let jobData = pageComponent?.state?.jobData;

  if (showProjectTotal && jobData && jobData.JobNum && jobData.JobNum.includes('/')) {
    // 调用后端接口查询同 Project 下所有 Job 的 Quote 总和
    httpClient
      .get('Business/Quote/GetProjectTotal?jobId=' + jobData.JobId)
      .then(({ data }) => {
        if (data.result) {
          let projectTotal = data.data;
          sectionComponent.props.parentComponent.setState({
            tableFooter: <div>
              <span>{'Total: ' + globalFunction.formatMoney(total)}</span>
              <span style={{ marginLeft: '30px' }}><CustomBadge text={'Project Total: ' + globalFunction.formatMoney(projectTotal)} backgroundColor="#03A9F4" /></span>
            </div>
          });
        }
      })
      .catch(() => {
        sectionComponent.props.parentComponent.setState({ tableFooter: 'Total: ' + globalFunction.formatMoney(total) });
      });
  } else {
    sectionComponent.props.parentComponent.setState({ tableFooter: 'Total: ' + globalFunction.formatMoney(total) });
  }
}

//加载 QuoteTemplate
export function loadQuoteTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('Admin/QuoteTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Content: data.data.Content });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Date 和 DueDate 设置添加时的默认值
export function addQuotePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let lineItemForm = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
  lineItemForm?.addLineItem(true);
  sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Date: moment(new Date(), config.format.date), ExpiryDate: moment(globalFunction.addDate(new Date(), pageComponent.props.authUser.Company.QuoteDefaultDuedays), config.format.date) });
}

export function dateOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ExpiryDate', moment(globalFunction.addDate(parameter.toDate(), pageComponent.props.authUser.Company.QuoteDefaultDuedays), config.format.date));
}

// 展开或收起全部 Quote 明细行
export function collapseQuote({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.current?.toggleAllRows();
}
